import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import Login from './components/Login';
import Register from './components/Register';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Home from './pages/Home';
import Categories from './pages/Categories';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Account from './pages/Account';
import AboutUs from './pages/AboutUs';
import PlanWeek from './pages/PlanWeek';
import KnowYouBetter from './pages/KnowYouBetter';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes with Layout */}
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Layout>
                  <Home />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <PrivateRoute>
                <Layout>
                  <Categories />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <Layout>
                  <Cart />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Layout>
                  <Checkout />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/account"
            element={
              <PrivateRoute>
                <Layout>
                  <Account />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/about-us"
            element={
              <PrivateRoute>
                <Layout>
                  <AboutUs />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/plan-week"
            element={
              <PrivateRoute>
                <Layout>
                  <PlanWeek />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/know-you-better"
            element={
              <PrivateRoute>
                <KnowYouBetter />
              </PrivateRoute>
            }
          />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/categories" replace />} />
          <Route path="*" element={<Navigate to="/categories" replace />} />
        </Routes>
      </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
